export default {
  client: "CLIENTE",
  name: "NOMBRE",
  quote: "COTIZACIÓN",
  invoice: "FACTURA",
  date: "FECHA",
  download_invoice: "Descargar factura",
  send_notification: "Enviar notificación",
  trip_programme: "PROGRAMA_VIAJE",
  pax: "Pax",
  total_program: "Programa_total",
  total_deposit: "DEPÓSITO_TOTAL",
  payment_method: "MÉTODO_PAGO",
  bank_transfer: "TRANSFERENCIA BANCARIA",
  bank_name: "NOMBRE_BANCO",
  iban: "IBAN",
  swift_bic: "SWIFT/BIC",
  address: "DIRECCIÓN",
  concept: "CONCEPTO",
  trip_details: {
    case_name: "NOMBRE_CASO",
    destination: "DESTINO",
    accommodation: "ALOJAMIENTO",
    transfer: "TRANSFERENCIA",
    ebike: "BICICLETA ELÉCTRICA",
    luggage_transfer: "EQUIPAJE TRANSFERENCIA",
    date: "FECHA"
  }
}
